import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=6da4b5ef&scoped=true"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"
import style0 from "./Insight.vue?vue&type=style&index=0&id=6da4b5ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da4b5ef",
  null
  
)

export default component.exports